<div [class]="classes" [innerHTML]="widget.text"></div>
